<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="839"
  >
    <v-card v-if="visible" class="v-dialog--import">
      <v-card-title class="dialog__header">
        <span class="dialog__title">
          <Label :value="lines.length" colored error icon />
          <span>{{ $t(`${namespace}.title`) }}</span>
        </span>

        <v-btn
          class="v-dialog--custom__close"
          :disabled="isLoading"
          icon
          @click="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="dialog__body">
        <label style="position: relative;">
          <p v-if="isLoading">{{ $t('Views.BulkImportPage.uploadBox.status.loading') }}</p>
          <p v-else v-html="$t(`${namespace}.text`)" />

          <XLSXInput
            class="upload__input upload__input--hide"
            :maxLines="maxLines"
            :worksheetTarget="worksheetTarget"
            :supportedFileTypes="supportedFileTypes"
            @change="handleChange"
            @success="handleSuccess"
            @error="handleError"
          />
        </label>
      </v-card-text>

      <Table
        type="employee"
        :headers="[{ text: $t(`${namespace}.line`) }, { text: $t(`${namespace}.error`) }]"
        :items="lines.map(({ lineNumber, messages }) => ({ lineNumber, message: messages[0] }))"
        striped
        hover
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { isValidArray, isValidObject } from 'corp-front-vue-commons/src/utils/functions'
import XLSXInputMixin from 'mixins/XLSXInput'
import uploadBoxMixin from 'mixins/uploadBox'
import Table from 'components/Table'
import Label from 'components/bulkImport/Label'
import XLSXInput from 'components/bulkImport/stepOne/XLSXInput'

export default {
  name: 'DialogLinesWithErrors',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String
    },
    lines: {
      type: Array,
      default: () => []
    },
    maxLines: {
      type: Number
    },
    worksheetTarget: {
      type: [String, Array]
    },
    supportedFileTypes: {
      type: Array
    }
  },
  mixins: [XLSXInputMixin, uploadBoxMixin],
  components: {
    Label,
    XLSXInput,
    Table
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.dialogLinesWithErrors',
      requestStatus: true,

      table: {
        headers: [],
        items: []
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    isValidArray (val) {
      return isValidArray(val)
    },

    isValidObject (val) {
      return isValidObject(val)
    }
  }
}
</script>

<style lang="scss">
.v-dialog--import {

  .dialog__header {
    display: flex;
    justify-content:  space-between;
  }

  .dialog__title {
    align-items: center;
    display: flex;

    span {
      margin-left: 16px;
    }
  }

  .upload__input--hide {
    left: -9999em;
    position: absolute;
    top: -9999em;
  }
}
</style>
